import type { FC } from 'react';
import { GoToTest } from 'features/cabinet';
import { CabinetTitlePage } from 'components/layout';
import { Add } from '@mui/icons-material';
import { LinkButton } from 'components/common';
import { Guard, usePermissionGuard } from 'features/login';

const GoToTestPage: FC = () => {
  const { accessToAddGototest, accessToViewGototest } = usePermissionGuard();

  return (
    <Guard hasAccess={accessToViewGototest} fallback>
      <CabinetTitlePage
        title={'Go to test'}
        endAdornment={
          <LinkButton
            disabled={!accessToAddGototest}
            to={'/cabinet/facebook/go-to-test/add'}
            title={'Add Go to test'}
            startIcon={<Add />}
          />
        }
      />
      <GoToTest />
    </Guard>
  );
};

export default GoToTestPage;
